export default "__VITE_ASSET__CPPg5ATt__"